import NoticesPanel from './NoticesPanel';
export default NoticesPanel;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/NoticesPanel/index.js